import { render, staticRenderFns } from "./slots.vue?vue&type=template&id=9cb16472&scoped=true"
import script from "./slots.vue?vue&type=script&lang=js"
export * from "./slots.vue?vue&type=script&lang=js"
import style0 from "./slots.vue?vue&type=style&index=0&id=9cb16472&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../tmp/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb16472",
  null
  
)

export default component.exports